import { useMutation, useQueryClient } from '@tanstack/react-query';
import { ErroreApi, chiama } from './cliente.js';
import { t } from '../i18n/lingua.js';

/**
 * Il PDF della fattura sull'ordine.
 *
 * Sono due — parte SPA e parte Inc — e restano due perché la triangolazione
 * è reale: la merce parte dalla S.p.A. e arriva al cliente attraverso la Inc.
 */

export type Societa = 'spa' | 'inc';

export interface FatturaSuOrdine {
  orderId: number;
  issuer: Societa;
  fileName: string;
  fileSize: number | null;
  downloadName: string;
}

export function useAttaccaFattura(ordineId: number) {
  const client = useQueryClient();
  return useMutation({
    mutationFn: async ({ file, issuer }: { file: File; issuer: Societa }) => {
      const dati = new FormData();
      dati.append('file', file);

      const risposta = await fetch(`/api/orders/${ordineId}/invoice-file/${issuer}`, {
        method: 'POST',
        body: dati,
        credentials: 'same-origin',
      });
      const corpo = await risposta.json().catch(() => null);
      if (!risposta.ok) {
        throw new ErroreApi(
          corpo?.error ?? 'erroreCaricamento',
          corpo?.message ?? t('Il caricamento non è riuscito.'),
          risposta.status,
        );
      }
      return corpo as FatturaSuOrdine;
    },
    onSuccess: () => client.invalidateQueries({ queryKey: ['ordine', ordineId] }),
  });
}

export function useStaccaFattura(ordineId: number) {
  const client = useQueryClient();
  return useMutation({
    mutationFn: (issuer: Societa) =>
      chiama<{ deleted: boolean }>(`/api/orders/${ordineId}/invoice-file/${issuer}`, {
        metodo: 'DELETE',
      }),
    onSuccess: () => client.invalidateQueries({ queryKey: ['ordine', ordineId] }),
  });
}

/** L'indirizzo da cui scaricare: il browser ci va da solo, col cookie. */
export function indirizzoFattura(ordineId: number, issuer: Societa): string {
  return `/api/orders/${ordineId}/invoice-file/${issuer}/download`;
}
